import { render, staticRenderFns } from "./SelectVer.vue?vue&type=template&id=6498a736&lang=true&"
import script from "./SelectVer.vue?vue&type=script&lang=js&"
export * from "./SelectVer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports